import React, { useState, useEffect } from "react";
import { Button, Icon } from "semantic-ui-react";
import "../TemplateManager.scss";

export const Sev01 = React.memo((props) => {
  const { slideId, onLetterByOrder, activeSession, shuffleArray } = props;
  const [question, setQuestion] = useState("");
  const [choices, setChoices] = useState([]);

  /**
   * Updates the component state with the content of the selected slide in Sev01.js.
   *
   * This `useEffect` hook is triggered whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's question and choices.
   *
   * Specifically, it performs the following actions:
   * - Sets the `question` state with the slide's question, converting newline characters to `<br />` for HTML rendering.
   * - Sets the `choices` state with a shuffled array of the slide's choices to randomize their order.
   *
   * This ensures that the component reflects the content of the currently selected slide, displaying the question
   * and choices in a randomized order for the user. This is crucial for maintaining user engagement and fairness in quizzes or surveys.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setQuestion(slide.content.question.replace(/\n/g, "<br />"));
      setChoices(shuffleArray([...slide.content.choices]));
    }
  }, [slideId]);

  return (
    <div className="row">
      <h3 className="show-slide__title">
        <Icon name="question" />
        Pregunta:
      </h3>
      <div className="show-slide__body">
        <p
          className="show-slide__text"
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <div>
          {choices.map((choice, choiceIndex) => (
            <div key={choiceIndex}>
              <Button
                className="show-slide__choice"
                content={`${onLetterByOrder(choiceIndex + 1)}.`}
                label={{
                  className: "show-slide__choice-label",
                  basic: true,
                  pointing: "left",
                  content: `${choice.answer}`,
                }}
                labelPosition="right"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
